<template>
    <div class="travelsearch">
        <div class="search-box">
            <div class="input-box">
                <img src="../../assets/travelAgency/ic_search.png" alt class="search-icon" />
                <input style type="text" placeholder="搜索姓名" class="search-input" v-model="inputValue"
                    @input="onChange" />
            </div>
            <div class="search-btn" @click="cancal">取消</div>
        </div>

        <div class="history-box mb20" v-if="inputValue == '' && keyword.length > 0">
            <div class="title-box">
                <div class="title">最近搜索</div>

            </div>
            <div class="lists-box">
                <div class="items-box" v-for="(items,idx) in keyword" v-if="idx < 10" :key="idx">
                    <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="headimg" />
                    <div class="info-box">
                        <div class="username">{{items.name}}</div>
                        <div class="phone">{{items.mobile}}</div>
                    </div>
                    <div class="phone-box" @click="sendMessage(items)">
                        <van-icon name="chat" color="#36b374" size="15" :dot="!!items.unreadCount" />
                    </div>
                    <div class="phone-box"
                         @click="playPhone(items)">
                        <!-- <div class="times">{{items.timer}}</div> -->
                        <a>
                            <img src="../../assets/index/ic_ts_dh.png" alt class="phone-icon" />
                        </a>
                    </div>
                </div>
            </div>

        </div>
        <!-- <empty :type="3" v-if="inputValue == '' && keyword.length === 0 && history.length === 0"></empty> -->
        <div class="result-box" v-if="inputValue != ''">
            <div class="title-box">
                <div class="title">搜索结果</div>
            </div>

            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMoreList"
                v-if="listData.length > 0">
                <div class="lists-box">
                    <div class="items-box" v-for="(items,idx) in listData" :key="idx+'y'">
                        <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="headimg" />
                        <div class="info-box">
                            <div class="username">{{items.name}}</div>
                            <div class="phone">{{items.mobile}}</div>
                        </div>
                        <div class="phone-box" @click="sendMessage(items)">
                            <van-icon name="chat" color="#36b374" size="15" :dot="!!items.unreadCount" />
                        </div>
                        <div class="phone-box" @click="playPhone(items)">
                            <!-- <div class="times">{{items.timer}}</div> -->
                            <a>
                                <img src="../../assets/index/ic_ts_dh.png" alt class="phone-icon" />
                            </a>
                        </div>
                    </div>
                    <div class="items-box2" v-for="(items,idx) in list" :key="idx+'z'" @click="toPersonList(items,idx)">
                        <img src="../../assets/index/ic_bm_qz.png" alt class="file-icon" />
                        <div class="centertext">{{items.name}}</div>
                        <img src="../../assets/index/ic_bm_jt.png" alt class="right-icon" />
                    </div>
                </div>

            </van-list>
            <empty :type="2" v-if="listData.length === 0 && !loading"></empty>
        </div>
        <callPhone ref="callPhone" :combinPhone="combinPhone" :userInfo="userInfo"></callPhone>
    </div>
</template>
<script>
    import api from 'apis';
    import {
        mapState
    } from 'vuex';
    import empty from 'comps/empty';
    import callPhone from 'comps/callPhone';
    import mixin from '@/mixins/index';
        import instantMessagingApi from '@/service/modules/instantMessaging';

    export default {
        components: {
            callPhone,
            empty
        },
        mixins: [mixin],

        data () {
            return {
                inputValue: '',
                listData: [],
                finished: false,
                loading: false,
                page: 1,
                total: 0,
                oldInputValue: '',
                cityId: '',
                list: [],
                combinPhone: 0,
	            userInfo: {}
            };
        },

        computed: {
            ...mapState('home', ['keyword', 'currentUserInfo']),
            contacts () {
                return this.$store.getters['home/contactsList']
            }
        },

        watch: {},

        methods: {
            toPersonList (item) {
                // this.$router.push(`/provincemaillist?id=${item.id}&title=${encodeURI(item.name)}&type=1`)
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: `${this.globalApp.getSystemInfo().host}web/#/provincemaillist?id=${item.id}&title=${encodeURI(item.name)}&type=1`,
                        isFullScreen: 0,
                        setTitle: item.name,
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            },
            cancal () {
                this.$router.go(-1)
            },
            playPhone (item) {
                let list = [];
                list.push(item);
                this.keyword.forEach(element => {
                    if (element.mobile !== item.mobile && list.length < 10) {
                        list.push(element);
                    }
                });
                this.$store.dispatch('home/setKeyword', list); // 设置浏览记录

                this.call(item);
                this.combinPhone = Number(item.mobile);
	            this.userInfo = {
		            targetName: item.name,
		            targetId: item.staffCode,
		            userId: this.currentUserInfo.staffCode,
		            name: this.currentUserInfo.name
	            };
                this.$refs.callPhone.showBox();
            },
            loadMoreList () {
                this.getData();
            },
            getData () {
                this.loading = true;
                let data = {
                    keywords: this.inputValue
                };

                api.searchaddressbook(data).then(res => {
                    if (res.ret === 0) {
                        this.loading = false;
                        this.listData = res.data.contacts
                        this.finished = true
                        this.list = res.data.units
                    } else {
                        this.loading = false;
                        this.listData = []
                        this.list = []
                    }
                });
            },
            latestDelete () {
                this.$store.dispatch('home/setKeyword', []); // 清空搜索记录
            },
            onChange (value) {
                if (this.inputValue === '') {
                    this.oldInputValue = ''
                    this.listData = this.history || [];
                    this.finished = true;
                } else {
                    if (this.oldInputValue !== this.inputValue) {
                        this.oldInputValue = this.inputValue;
                        this.page = 1;
                        this.listData = [];
                        if (!this.loading) {
                            this.getData();
                        }
                    }
                }
            },
	        async sendMessage(item) {
		        if (this.currentUserInfo.name) {
			        await api.importAccount({
				        nick: this.currentUserInfo.name,
				        identifier: `yjg_${this.currentUserInfo.staffCode}`
			        });
		        }
		        if (item.name) {
			        await api.importAccount({
				        nick: item.name,
				        identifier: `yjg_${item.staffCode}`
			        });
		        }

		        let value = {
			        targetId: item.staffCode,
			        userId: this.currentUserInfo.staffCode,
                    currentConversationType: 'C2C'
		        };
		        let str = [];
		        for (let key in value) {
			        str.push(key + '=' + value[key]);
		        }
		        let query = str.join('&');
		        if (process.env.NODE_ENV === 'development') {
			        this.$router.push({
				        path: `/personalChat?${query}`
			        })
		        }
		        window.yyn.invokeJSB(
			        'openWindow',
			        {
				        openUrl: `${this.globalApp.getSystemInfo().host}web/#/personalChat?${query}`,
				        isFullScreen: 1,
				        setTitle: '',
				        needLoading: 1
			        },
			        cb => {
				        console.log(cb, 'callback');
			        }
		        );
	        }
        },

        mounted () {
            this.$store.dispatch('home/reLoadKeyword')

            this.inputValue = ''
            this.onChange(this.inputValue)
        },
        created () {}
    };
</script>
<style scoped lang="less">
    @vv: 3.75vw;

    .travelsearch {
        width: 100%;
        height: 100%;
        background: rgba(251, 251, 251, 1);
        box-sizing: border-box;
        padding: 10 / @vv 12 / @vv 0 12 / @vv;

        .search-box {
            height: 28 / @vv;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 25 / @vv;

            .input-box {
                flex: 1;
                margin-right: 12 / @vv;
                height: 100%;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding-left: 16 / @vv;
                background: rgba(245, 245, 245, 1);
                border-radius: 1 / @vv;

                .search-icon {
                    width: 15 / @vv;
                    height: 14 / @vv;
                    margin-right: 8 / @vv;
                }

                input::-webkit-input-placeholder {
                    font-size: 12 / @vv;

                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 17 / @vv;
                }

                .search-input {
                    flex: 1;
                    background: rgba(245, 245, 245, 1);
                }
            }

            .search-btn {
                width: 40 / @vv;
                height: 28 / @vv;
                background: rgba(245, 245, 245, 1);
                border-radius: 1 / @vv;
                font-size: 12 / @vv;

                font-weight: 400;
                color: rgba(54, 179, 116, 1);
                line-height: 28 / @vv;
                text-align: center;
            }
        }

        .latest-box {
            margin-bottom: 28 / @vv;

            .title-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 12 / @vv;

                .title {
                    font-size: 16 / @vv;

                    font-family: PingFang SC, Arial, sans-serif;
                    -webkit-font-smoothing: antialiased;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    line-height: 16 / @vv;
                }

                .delete-icon {
                    width: 18 / @vv;
                    height: 18 / @vv;
                }
            }

            .tags-box {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .tag {
                    font-size: 12 / @vv;
                    // font-family: PingFangTC-Regular, PingFangTC;
                    font-weight: 400;
                    color: rgba(102, 102, 102, 1);
                    line-height: 28 / @vv;
                    box-sizing: border-box;
                    padding: 0 8 / @vv;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 1 / @vv;
                    border: 1 / @vv solid rgba(204, 204, 204, 1);
                    margin-right: 16 / @vv;
                    margin-bottom: 10 / @vv;
                }
            }
        }

        .history-box,
        .result-box {
            .title-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 12 / @vv;

                .title {
                    font-size: 16 / @vv;

                    font-family: PingFang SC, Arial, sans-serif;
                    -webkit-font-smoothing: antialiased;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    line-height: 16 / @vv;
                }

                .delete-icon {
                    width: 18 / @vv;
                    height: 18 / @vv;
                }
            }

            .lists-box {
                overflow: hidden;
                box-shadow: 0/@vv 0/@vv 10/@vv 0/@vv rgba(0, 0, 0, 0.04);
                border-radius: 3/@vv;

                .items-box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #fff;
                    height: 68/@vv;
                    box-sizing: border-box;
                    padding: 16/@vv;
                    border-bottom: 1/@vv solid #eeeeee;

                    &:last-child {
                        border-bottom: none;
                    }

                    .headimg {
                        width: 36/@vv;
                        height: 36/@vv;
                        margin-right: 12/@vv;
                    }

                    .info-box {
                        flex: 1;
                        text-align: left;

                        .username {
                            height: 20/@vv;
                            font-size: 16/@vv;
                            // font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: rgba(51, 51, 51, 1);
                            // line-height: 16/@vv;
                            line-height: 20/@vv;
                            margin-bottom: 4/@vv;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            width: 240/@vv;
                        }

                        .phone {
                            height: 12/@vv;
                            font-size: 12/@vv;
                            // font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: rgba(153, 153, 153, 1);
                            line-height: 12/@vv;
                        }
                    }

                    .phone-box {
                        display: flex;
                        align-items: center;

                        .times {
                            height: 12/@vv;
                            font-size: 12/@vv;
                            // font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: rgba(153, 153, 153, 1);
                            line-height: 12/@vv;
                            margin-right: 12/@vv;
                        }

                        .phone-icon {
                            width: 14/@vv;
                            height: 16/@vv;
                        }
                    }

                    .phone-box + .phone-box {
                        margin-left: 10px;
                    }
                }

                .items-box2 {
                    height: 67/@vv;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    box-sizing: border-box;
                    padding: 16/@vv;
                    border-bottom: 1/@vv solid #eee;

                    &:last-child {
                        border-bottom: none;
                    }

                    .file-icon {
                        width: 36/@vv;
                        height: 36/@vv;
                        margin-right: 12/@vv;
                    }

                    .centertext {
                        height: 20/@vv;
                        font-size: 16/@vv;
                        // font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 20/@vv;
                        flex: 1;
                        text-align: left;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        width: 250/@vv;
                    }

                    .right-icon {
                        width: 9/@vv;
                        height: 15/@vv;
                        // margin-right: 8/@vv;
                    }
                }
            }

        }
    }
</style>
